/**
 * Normalizácia reťazca pre porovnanie (odstránenie diakritiky, lowercase).
 * Použitie: filtrovanie v multiselectoch, header filtre.
 * @param {string} str
 * @returns {string}
 */
export function normalizeForMatch(str) {
  if (str == null) return '';
  const s = String(str).trim();
  if (s === '') return '';
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
